import React, { Component } from 'react';
import CSSModules from 'react-css-modules'
import Helmet from 'react-helmet'
import {
  Link,
  LinkIcon,
  GetStartedInput
} from '../../components'
import Styles from './NotFound.css'

@CSSModules(Styles)
export default class NotFound extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    return (
      <div>
        <div styleName='main'>
          <div styleName='notfound'>
            <Helmet title='404 Not found'/>
            <h1>Sorry, nothing here.</h1>
            <p>
              Use the search below, or <Link xstrong={true} to={'/'} title='Home'> click here to return to the home page <LinkIcon /></Link>
            </p>
          </div>
        </div>
        <div styleName='signup-wrap'>
          <GetStartedInput/>
        </div>
      </div>
    )
  }
}
